<template>
  <div class="wrapper">
    <div class="background-gradient" :style="cssProps"></div>
    <the-header @toggleProfile="handleProfileToggle"
                :showOrg="false" :show-filters="false"></the-header>
    <main role="main" class="main d-flex align-items-center h-100"
          :class="{'animate__backInDown': isAnimate }"
          v-if="organizations.length > 0">
      <div class="container-fluid h-100 pb-7 courses">
        <div class="row mb-5">
          <div class="col-md-4 offset-md-4 text-center">
            <h3 class="font-weight-light mb-4">
              {{ $t('instance.select') }}
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="w-100" style="z-index: 2">
            <div class="d-flex flex-wrap
             align-items-center justify-content-center" style="gap: 2rem">
              <span
                v-for="organization in organizations" :key="organization.id"
                class="organization-card d-flex flex-column
                align-items-center text-center cursor-hand"
                @click="setOrganization(organization.id)">
                <span class="bg-darktrans d-flex align-items-center w-226px h-137px rounded mb-2">
                  <span class="card-image d-block mt-0 mx-auto organization-logo w-100 h-100
                        d-flex align-items-center justify-content-center">
                    <img v-if="organization.logo"
                         :src="getOrganizationLogo(organization.id)"
                         class="img-fluid" alt="">
                    <img v-else src="@/assets/images/logo/VTS_Perform_White.svg"
                         class="img-fluid w-100" alt="">
                  </span>
                </span>
                <span class="display-h4 cursor-default d-flex">{{ organization.name }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </main>
    <main class="main" v-if="organizations.length === 0">
      <div class="d-flex align-items-center justify-content-around">
        <img src="@/assets/images/Avatar-Homme.png" class="avatar  d-block">
        <div class="no-session_text position-absolute  w-400p">
          <div class="d-flex justify-content-center align-items-center display-h2">
            <span>{{ $t('app.where.is.sessions') }}</span>
          </div>
          <div class="d-flex justify-content-center align-items-center
        display-h5 text-center mt-5 w-100">
            <span>{{ $t('app.no.sessions.available') }}</span>
          </div>
        </div>
        <img src="@/assets/images/Avatar-Femme.png" class="avatar d-none d-md-block">
      </div>
    </main>
    <section class="mt-auto"></section>
    <ProfileCanvas :class="{'offcanvas-on': showProfile}" @close="handleProfileToggle"
                   :showOrg="false"
                   @togglePasswordForm="updateShowPasswordForm" />
    <ForumCanvas :class="{'offcanvas-on': showForum}" @close="updateShowForum"/>
    <PasswordCanvas :class="{'offcanvas-on': showPassword}" @close="updateShowPasswordForm"/>
    <div v-if="!orgsCliquables"
          class="position-absolute wrapper home-page vh-100 align-content-center"
          style="z-index: 100;"
         :class="{'fade-out': !showProfileLoading }">
      <div class="background-image" :style="cssProps"></div>
      <div class="d-flex justify-content-center"
           style="margin: auto;padding: 10px;">
        <div style="z-index: 1;">
          <div class="user-info d-flex flex-column align-items-center ml-auto cursor-hand"
               @click.stop="updateShowProfile">
            <div class="user-info__image rounded-circle position-relative">
              <img
                v-if="currentUser.avatarURL"
                class="cover-fit border-pad w-150px h-150px"
                :src="userAvatar"
                alt="">
              <div v-else class="avatar-placeholder w-150px h-150px" style="font-size: 80px">
                {{ currentUser.initials }}
              </div>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center display-h2">
              <span>{{ $t('profile.hello') }} {{ currentUser.firstName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelperMixin from '@/mixins/helperMixin';
import { FETCH_ORGANIZATIONS } from '@/store/actions.type';
import { mapGetters } from 'vuex';
import store from '@/store';
import { SET_ORGANIZATION_ID } from '@/store/mutations.type';
import ProfileCanvas from '@/components/canvas/ProfileCanvas.vue';
import ForumCanvas from '@/components/canvas/ForumCanvas.vue';
import PasswordCanvas from '@/components/canvas/PasswordCanvas.vue';
import TheHeader from './TheHeader.vue';

export default {
  name: 'Organizations',
  mixins: [HelperMixin],
  components: {
    TheHeader, ProfileCanvas, ForumCanvas, PasswordCanvas,
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(FETCH_ORGANIZATIONS, {})
      .then(() => {
        if (store.getters.organizations.length === 1) {
          setTimeout(() => {
            store.commit(SET_ORGANIZATION_ID, store.getters.organizations[0].id);
            next({ name: 'Homepage' });
          }, 1000);
        }
        next();
      });
  },
  mounted() {
    this.setOrgCSS(true);
    setTimeout(() => {
      this.showProfileLoading = false;
      setTimeout(() => {
        this.orgsCliquables = true;
      }, 1500);
    }, 1500);
  },
  data() {
    return {
      cssProps: {
        // eslint-disable-next-line global-require
        backgroundImage: `url(${require('@/assets/images/background.jpg')})`,
      },
      noOrganization: false,
      isAnimate: false,
      showProfileLoading: true,
      orgsCliquables: false,
      showProfile: false,
      showPassword: false,
      showForum: false,
    };
  },
  computed: {
    ...mapGetters(['organizations', 'currentUser', 'userAvatar']),
  },
  methods: {
    setOrganization(organizationId) {
      this.isAnimate = true;
      this.$store.commit(SET_ORGANIZATION_ID, organizationId);
      this.$router.push({ name: 'Homepage' });
    },
    updateShowPasswordForm(event) {
      const { src } = event;
      this.showPassword = src === 'profile';
    },
    handleProfileToggle(event) {
      const { src } = event;
      this.showProfile = src === 'header';
    },
    updateShowForum() {
      this.showForum = !this.showForum;
    },
  },
};
</script>

<style scoped lang="scss">
.organization-logo {
  img {
    max-width: 85%;
    max-height: 85%;
  }
}
</style>
